import * as React from "react"

const SvgComponent = ({fill}) => (
  <svg
    width={20}
    height={20}
    fill="none"
    
  >
    <path
      d="M19.091 7.273h-3.636c-.91 0-.91 0-.91.909v3.636c0 .91 0 .91.91.91h3.636c.909 0 .909 0 .909-.91V8.182c0-.91 0-.91-.91-.91h.001ZM11.818 0H8.182c-.91 0-.91 0-.91.909v3.636c0 .91 0 .91.91.91h3.636c.91 0 .91 0 .91-.91V.91c0-.909 0-.909-.91-.909Zm7.273 14.545h-3.636c-.91 0-.91 0-.91.91v3.636c0 .909 0 .909.91.909h3.636C20 20 20 20 20 19.09v-3.636c0-.909 0-.909-.91-.909h.001Zm-7.273-7.272H8.182c-.91 0-.91 0-.91.909v3.636c0 .91 0 .91.91.91h3.636c.91 0 .91 0 .91-.91V8.182c0-.91 0-.91-.91-.91ZM4.545 0H.91C0 0 0 0 0 .909v3.636c0 .91 0 .91.909.91h3.636c.91 0 .91 0 .91-.91V.91c0-.909 0-.909-.91-.909Zm7.273 14.545H8.182c-.91 0-.91 0-.91.91v3.636c0 .909 0 .909.91.909h3.636c.91 0 .91 0 .91-.91v-3.635c0-.91 0-.91-.91-.91ZM4.545 7.273H.91c-.909 0-.909 0-.909.909v3.636c0 .91 0 .91.909.91h3.636c.91 0 .91 0 .91-.91V8.182c0-.91 0-.91-.91-.91Zm0 7.272H.91c-.909 0-.909 0-.909.91v3.636C0 20 0 20 .909 20h3.636c.91 0 .91 0 .91-.91v-3.636c0-.909 0-.909-.91-.909ZM19.091 0h-3.636c-.91 0-.91 0-.91.909v3.636c0 .91 0 .91.91.91h3.636c.909 0 .909 0 .909-.91V.91C20 0 20 0 19.09 0h.001Z"
      fill={fill}
    />
  </svg>
)

export default SvgComponent